export const initialState = {
  global: {
    networkId:
      localStorage.getItem("networkId") !== "" &&
      localStorage.getItem("networkId") !== null
        ? localStorage.getItem("networkId")
        : "",
  },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "changeNetworkId":
      var a = {
        global: { ...state.global, networkId: action.newNetworkId.networkId },
      };
      return a;
      break;
    default:
      return state;
  }
};
